<div class="container mx-auto px-4 py-8">
  <h1 class="text-3xl font-bold mb-6">Izjava o privatnosti</h1>
  
  <div class="bg-white rounded-lg shadow-md p-6">
    <p class="mb-4">
      Foto Studio A-1 daje izjavu o privatnosti kako bismo pokazali brigu o privatnosti korisnika naših usluga i naše aplikacije <strong>Foto2Print</strong>.
    </p>
    
    <h2 class="text-xl font-semibold mb-4">Prikupljanje i obrada podataka</h2>
    <p class="mb-4">
      Foto Studio A-1 upotrebljava ime, prezime i telefonski broj korisnika usluge <strong>Foto2Print</strong> isključivo za potrebe identifikacije naručitelja usluge i za uspostavu primarnog kanala komunikacije s korisnikom usluge.
      Datoteke poslane na izradu korištenjem naše aplikacije (radi se o digitalnim fotografijama) koriste se samo za ispisivanje, tj. izradu tako naručenih fotografija.
    </p>
    
    <h2 class="text-xl font-semibold mb-4">Poveznice s trećim stranama</h2>
    <p class="mb-4">
      Naša aplikacija <strong>Foto2Print</strong> ne komunicira niti razmjenjuje bilo kakve podatke ili sadržaje s trećim stranama.
    </p>
    
    <h2 class="text-xl font-semibold mb-4">Pohrana i rok čuvanja podataka</h2>
    <p class="mb-4">
      Vaši osobni podaci koje ste upisali prilkom prijave u aplikaciju <strong>Foto2Print</strong> čuvaju se dok ste korisnik naše aplikacije.
      Datoteke poslane na izradu se ne čuvaju, nego se brišu odmah po izvršenju usluge.
    </p>
    
    <h2 class="text-xl font-semibold mb-4">Vaš pristanak</h2>
    <p class="mb-4">
      Korištenjem naše aplikacije <strong>Foto2Print</strong> smatra se da ste dali pristanak na ovu politiku privatnosti.
    </p>
  </div>
</div>
